import React, { Component } from "react";
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

//Miscellaneous
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Fade, Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import Swal from "sweetalert2";

//Components
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import DataTable from "../../components/Datatable/DataTable";
import SideBar from "../../components/Sidebar/Sidebar";
import Button from "../../components/Button/Button";
import CryptoDepositModal from "../../components/CryptoDepositModal/CryptoDepositModal";
import { isDesktop } from "react-device-detect";

//Icons
import { Icon } from "@iconify/react";

// Actions
import * as actions from "../../store/ducks/transaction/actions";
import { getCryptoTransStatus } from "../../store/ducks/deposit/actions";
import MobileCommissionWallet from "./MobileCommissionWallet";

const filterCategories = [
  { id: "filterDeposit", value: "deposit", label: "deposit" },
  { id: "filterWithdrawal", value: "withdrawal", label: "withdrawal" },
  { id: "filterAgentPayout", value: "agent-payout", label: "agent-payout" },
  { id: "filterAgentTransfer", value: "agent-transfer", label: "agent-transfer" }
];

const filterDate = [
  { id: "filterToday", value: "0", label: "today" },
  { id: "filterYtd", value: "1", label: "yesterday" },
  { id: "filter7Day", value: "7", label: "last-7-days" },
  { id: "filter30Days", value: "30", label: "last-30-days" },
];

class CommissionWallet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      transaction_type: 'deposit',
      currentFilterDate: 0,
      transaction_date: '',

      /* datatables / pagination */
      activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
      limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
      totalRecords: 0,

      /* api result array */
      data: [],

      /* skeleton loading */
      loading: true,
      dropdownLoading: true,
      dates: null,

      /* crypto */
      openCryptoDepositModal: false,
      input: {
        amount: ""
      },
      cryptoPayment: "pending",
      refCode: "",
      txid: "",
      exchangeRate: "",
      usdtAmt: "",
      channel: "",
      type: "",

      time: {},
      timer: 0,
      seconds: 900,
      expiredDateTime: "",

      /* mobile */
      showDateSelect: false,
      showDate: '',
      selectedDate: '',

      spin: false
    };
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    const listingArr = this.getFilterArray();
    this.props.funcGetList(listingArr);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { t } = this.props;

    if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) {
      if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success') {
        this.setState({
          data: nextProps.rs.data.result.row,
          totalRecords: nextProps.rs.data.result.pagination.total_record,
          loading: false,
          disableSearchButton: false,
        });
      }
    }

    if (nextProps.cancel !== this.props.cancel && nextProps.cancel !== undefined) {
      if (nextProps.cancel.responseCode === 200 && nextProps.cancel.msgType === "success") {
        Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : '',
          icon: "success",
          title: t('global.success'),
          text : t('global.success'),
          showConfirmButton: true,
          confirmButtonText: t("global.ok"),
          customClass: (!isDesktop) ? {
            container: 'swal-mobile-container sucess',
            icon: 'swal-success-icon'
          } : [],
        }).then(() => {
          this.setState({
            data: [],
            loading: true
          }, () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
          });
        });
      }
      else {
        this.swalErrorHandler(nextProps.cancel.message[0]);
      }
    }

    if (nextProps.crypto_trans_status !== this.props.crypto_trans_status && nextProps.crypto_trans_status !== undefined) {
      let date = moment(nextProps.crypto_trans_status.data[0].expired_date);
      const current = moment(new Date(), "YYYY-mm-dd HH:mm:ss");

      var given = moment(date, "YYYY-mm-dd HH:mm:ss");

      const secondsLeft = moment.duration(current.diff(given)).asSeconds();

      let minusSeconds = 60 - secondsLeft;

      let timeLeftVar = this.secondsToTime(Math.abs(secondsLeft));

      let cryptoType = nextProps.crypto_trans_status.data[0].crypto;

      if (minusSeconds <= 0) {
        this.setState({
          txid: nextProps.crypto_trans_status.data[0].reference_code,
          refCode: nextProps.crypto_trans_status.data[0].payment_address,
          exchangeRate: nextProps.crypto_trans_status.data[0].rates,
          usdtAmt: nextProps.crypto_trans_status.data[0].crypto_amount,
          channel: nextProps.crypto_trans_status.data[0].crypto,
          type: cryptoType.split('-')[1],
          cryptoPayment: "reject",
          input: {
            amount: nextProps.crypto_trans_status.data[0].credit
          }
        })
      } else {
        this.setState({
          timer: 0,
          time: timeLeftVar,
          seconds: Math.abs(minusSeconds),
          txid: nextProps.crypto_trans_status.data[0].reference_code,
          refCode: nextProps.crypto_trans_status.data[0].payment_address,
          exchangeRate: nextProps.crypto_trans_status.data[0].rates,
          usdtAmt: nextProps.crypto_trans_status.data[0].crypto_amount,
          channel: nextProps.crypto_trans_status.data[0].crypto,
          cryptoPayment: (nextProps.crypto_trans_status.data[0].status === 1 ? "success" : nextProps.crypto_trans_status.data[0].status === 2 ? "reject" : "pending"),
          type: cryptoType.split('-')[1],
          input: {
            amount: nextProps.crypto_trans_status.data[0].credit
          },
          expiredDateTime: nextProps.crypto_trans_status.data[0].expired_date
        })
      }
    }

    return true;
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  }

  onInputChange = (event) => {
    if (event.target.id === 'transaction_date') {
      const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
      this.setState({
        start_date: (date[0]) ? moment(date[0]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        end_date: (date[1]) ? moment(date[1]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        transaction_date: event.target.value,
      });

      const startDate = moment(this.state.start_date);
      const endDate = moment(this.state.end_date);
      const diff = endDate.diff(startDate, 'days');

      // Only allow to get data between 3 months
      if (diff > 92) {
        this.setState({
          disableSearchButton: true
        })
      } else {
        this.setState({
          disableSearchButton: false
        })
      }
    }
    else {
      this.setState({
        [event.target.name]: event.target.value,
      }, () => {
        this.searchHandler();
      });
    }
  }

  searchHandler = () => {
    this.setState({
      activePage: 1,
      data: [],
      loading: true,
      disableSearchButton: true
    }, () => {
      const listingArr = this.getFilterArray();
      this.props.funcGetList(listingArr);
    });
  }

  filterDayRange = (val) => {
    // let days = Number(event.target.value);
    let days = val;
    let startDate = moment().subtract(days, "days").format("YYYY-MM-DD");
    let endDate = moment().format("YYYY-MM-DD");
    let transactionDate = `${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`;

    this.setState({
      start_date: startDate,
      end_date: endDate,
      transaction_date: transactionDate,
      filterRange: days
    }, () => {
      let startDate = moment(this.state.start_date);
      let endDate = moment(this.state.end_date);
      let dayRange = endDate.diff(startDate, 'days');
      let disableButton = null;
      if (!startDate.isSameOrBefore(endDate) || !endDate.isSameOrAfter(startDate) || dayRange > 92) {
        disableButton = true;
      } else {
        disableButton = false;
        // const listingArr = this.getFilterArray();
        // this.props.funcGetList(listingArr);
      }

      this.setState({
        disableSearchButton: disableButton
      })

      this.searchHandler();
    });
  }

  getFilterArray = () => {
    const listingArr = {};
    listingArr.page = this.state.activePage;
    listingArr.limit = this.state.limit;
    listingArr.start_date = this.state.start_date;
    listingArr.end_date = this.state.end_date;
    listingArr.country_id = this.props.currentUser.country_id;
    listingArr.lang_id = this.props.currentUser.language_id;
    listingArr.transaction_type = this.state.transaction_type;
    return listingArr;
  }

  datatablesChangeHandler = (val, tab, act) => {
    this.setState({
      data: [],
      loading: true,
      [act]: val
    }, () => {
      const listingArr = this.getFilterArray();
      this.props.funcGetList(listingArr);
    });
  }

  //Mobile//
  toggleShowDateSelect = (e, show) => {
    if (this.state.showDateSelect === false) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    this.setState({
      showDateSelect: !this.state.showDateSelect,
    });

    const startDate = moment(this.state.start_date);
    const endDate = moment(this.state.end_date);
    const diff = endDate.diff(startDate, 'days');

    if (show === 'startDate') {
      this.setState({
        showDate: 'startDate',
        selectedDate: this.state.start_date,
        disableSearchButton: (diff > 30) ? true : false
      })
    } else if (show === 'endDate') {
      this.setState({
        showDate: 'endDate',
        selectedDate: this.state.end_date,
        disableSearchButton: (diff > 30) ? true : false
      })
    }
  }

  onChangeDateHandler = (value) => {
    if (this.state.showDate === 'startDate') {
      this.setState({
        start_date: `${value.years}-${value.months}-${value.days}`,
      })
    } else if (this.state.showDate === 'endDate') {
      this.setState({
        end_date: `${value.years}-${value.months}-${value.days}`,
      })
    }
  }

  onChangeFilterDateHandler = (value, e) => {
    this.setState({
      currentFilterDate: value
    });
  }

  onResetHandler = () => {
    this.setState({
      transaction_type: 'deposit',
      currentFilterDate: 0,
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      transaction_date: "",
      spin: true
    }, () => {
      const listingArr = this.getFilterArray();
      this.props.funcGetList(listingArr);
    });

    setTimeout(() => this.setState({ spin: false }), 2000);
  }

  cancelHandler = (e, id) => {
    e.preventDefault();
    const { t } = this.props;
    Swal.fire({
      iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : '',
      title: t("global.confirmation"),
      text: t("global.would-you-like-to-proceed") + "?",
      icon: "warning",
      confirmButtonText: t("global.confirm"),
      showDenyButton: true,
      denyButtonText: t("global.cancel"),
      customClass: (!isDesktop) ? {
        container: "swal-mobile-container confirmation",
        icon: "swal-confirmation-icon",
      } : [],
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        let data = {};
        data.id = id;
        this.props.funcCancelWithdraw(data);
      }
    });
  }

  openCryptoModalHandler = (reference_code) => {
    let data = {};
    data.reference_code = reference_code;
    this.props.funcCryptoTransStatus(data);

    this.setState({
      openCryptoDepositModal: !this.state.openCryptoDepositModal
    });

    clearInterval(this.timer);
  }

  countDown = () => {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;

    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(this.timer);
    }
  };

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds.toString().padStart(2, "0"),
    };

    return obj;
  }

  swalErrorHandler = (msg) => 
  {
    const { t } = this.props;
    Swal.fire({
        iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : '',
        title: t("global.error"),
        text: msg,
        icon: 'error',
        confirmButtonText: t('global.ok'),
        customClass: (!isDesktop) ? {
            container: "swal-mobile-container failed",
            icon: "swal-failed-icon",
        } : [],
    }).then(() => {
        // let newTab = Object.assign({}, this.state[this.state.historyTab]);
        // newTab['loading'] = false;

        this.setState({
            // [this.state.historyTab]: newTab,
            disableSearchButton: false,
        });
    });
  }

  render() {
    const { t } = this.props;
    const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
    const resetIcon = this.imageImport(
      require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/)
    );

    let rsData = [];
    let stCls = { 0: "on-going", 1: "success", 2: "failed", 3: "on-going", 4: "failed" };
    let stVal = { 0: t("history.pending"), 1: t("history.success"), 2: t("history.reject"), 3: t("history.processing"), 4: t("history.cancel") };
    const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

    const credit_transaction = ['deposit', 'agent-payout', 'agent-transfer'];
    const columns = [
      { text: t("history.date"), dataField: "create_date" },
      { text: t("history.order-id"), dataField: "order_id" },
      { text: t("history.amount"), dataField: "credit" },
      { text: t("history.method"), dataField: "method" },
      { text: t("history.type"), dataField: "transaction_type" },
      { text: t("history.status"), dataField: "status" },
      { text: t("global.action"), dataField: "action" }
    ];

    if (this.state.data) {
      rsData = this.state.data.map((val, idx) => {
        let actionVal = val.transaction_type_id === 2 && val.status === 0 ? (
          <button className="btn btn-action" onClick={(event) => this.cancelHandler(event, val.id)}>
            {t("history.cancel")}
          </button>
        ) : (
          <span>{"-"}</span>
        );
        let orderIdVal = val.status === 0 && val.transaction_channel === "crypto" ? (
          <div
            className="d-flex align-items-center justify-content-center btn-action no-hover"
            onClick={() => this.openCryptoModalHandler(val.reference_code)}
          >
            <span className="me-1">{val.order_id}</span>
            <Icon icon="uil:search" />
          </div>
        ) : (
          <span>{val.order_id}</span>
        )

        return {
          no: idx,
          create_date: moment(val.create_date).format("YYYY-MM-DD H:mm"),
          credit: credit_transaction.includes(val.transaction_type) ? new Intl.NumberFormat("en-US", num_format).format(val.credit) : new Intl.NumberFormat("en-US", num_format).format(val.debit),
          method: val.transaction_type_id === 1 ? t(`transaction-channel.${val.transaction_channel}`) : '-',
          transaction_type: t(`transaction-type.${val.transaction_type}`),
          action: actionVal,
          order_id: orderIdVal,
          status: val.status === 2 ? (
            <span role="button" className={` status ${stCls[val.status]}`}>
              {stVal[val.status]}
            </span>
          ) : (
            <span className={`${stCls[val.status]}`}>{stVal[val.status]}</span>
          )
        };
      });
    }

    const fadeUp = keyframes`
            from {
            opacity: 0;
            transform: translate3d(0, 50px ,0);
            }

            to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            }
        `;

    return (
      <Auxiliary>
        <CryptoDepositModal
          {...this.state}
          {...this.props}
          toggleCryptoDepositModalHandler={this.openCryptoModalHandler}
        />

        {isDesktop ? (
          <>
            <div className="pd-content">
              <div className="filters-col">
                <div className="filters-tp-panel ">
                  <div className="filters-tp-col">
                    <label className="col-form-label">{t('history.type')}:</label>
                    <div className="filters-group">
                      {filterCategories &&
                        filterCategories.map((item, index) => (
                          <div className="form-check form-check-inline filter" key={index}>
                            <input
                              className="btn-check"
                              type="radio"
                              name="transaction_type"
                              id={item.id}
                              value={item.value}
                              defaultChecked={index === 0}
                              checked={item.value === this.state.transaction_type}
                              onClick={(e) => this.onInputChange(e)}
                            />
                            <label className="btn form-check-label" htmlFor={item.id}>
                              {item.value === '' ? t(`global.all`) : t(`history.${item.label}`)}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="filters-bt-panel ">
                  <div className="filters-bt-col">
                    <label className="col-form-label">{t('history.date')}:</label>
                    <div className="filters-group" style={{ width: 'unset' }}>
                      {filterDate &&
                        filterDate.map((item, index) => (
                          <div className="form-check form-check-inline filter" key={index}>
                            <input
                              className="btn-check"
                              type="radio"
                              name="filterDate"
                              id={item.id}
                              value={item.value}
                              defaultChecked={index === 0}
                              checked={index === this.state.currentFilterDate}
                              onClick={(e) => this.onChangeFilterDateHandler(index, e)}
                            />
                            <label className="btn form-check-label" htmlFor={item.id} style={{ maxWidth: '75px' }} onClick={() => this.filterDayRange(item.value)}>
                              {t(`history.${item.label}`)}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="filters-bt-col">
                    <label className="col-form-label">{t('history.time')}:</label>
                    <div className="input-group right">
                      <DateTimePicker
                        id="transaction_date"
                        name="transaction_date"
                        className="form-control"
                        autoUpdateInput={true}
                        autoApply={true}
                        format="MM/DD/YYYY"
                        value={this.state.transaction_date}
                        onChange={this.onInputChange}
                      />
                      <span className="input-group-text">
                        <Icon icon="uil:calendar-alt" />
                      </span>
                    </div>
                    <Button
                      typeButton="button"
                      classValue="btn btn-gradient-blue"
                      idValue="search"
                      buttonName={t('global.check')}
                      clicked={() => this.searchHandler(this.state.transaction_type)}
                      disabled={this.state.disableSearchButton}
                    />
                    <div className="reset-btn">
                      <img className={`${this.state.spin ? "spin" : ""} `} src={resetIcon["rotate-icon.svg"]} alt="reset" onClick={this.onResetHandler} />
                    </div>
                  </div>
                </div>
              </div>

              <Reveal className="tab-pane fade show active" keyframes={fadeUp} duration={1000} triggerOnce>
                <span className="mx-2">&nbsp;</span>

                <Fade duration={1000} triggerOnce>
                  <DataTable
                    keyField="no"
                    data={rsData}
                    columns={columns}
                    activePage={this.state.activePage}
                    limit={this.state.limit}
                    totalItems={this.state.totalRecords}
                    paginationHandler={(val) => this.datatablesChangeHandler(val, 'deposit', "activePage")}
                    // sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'deposit', "limit")}
                    loading={this.state.loading}
                    hideSearchBar={true}
                    hideTotalRecords={true}
                    classValue="pd-table"
                    component="betting-history"
                  />
                </Fade>
              </Reveal>
            </div>
          </>
        ) : (
          <MobileCommissionWallet
            filterCategories={filterCategories}
            filterDate={filterDate}
            onInputChange={this.onInputChange}
            filterDayRange={this.filterDayRange}

            icons={icons}
            num_format={num_format}
            rsData={rsData}
            columns={columns}

            searchHandler={this.searchHandler}
            datatablesChangeHandler={this.datatablesChangeHandler}

            onChangeDateHandler={this.onChangeDateHandler}
            toggleShowDateSelect={this.toggleShowDateSelect}

            onResetHandler={this.onResetHandler}
            onChangeFilterDateHandler={this.onChangeFilterDateHandler}

            {...this.state}
            {...this.props}
          />
        )
        }
      </Auxiliary>
    );
  }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => {
  return {
    rs: state.transactionReport.rs,
    cancel: state.transactionReport.cancel,
    dropdown: state.transactionReport.dropdown,
    crypto_trans_status: state.deposit.crypto_trans_status,
    currentUser: state.currentUser.data
  }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => {
  return {
    funcGetList: (filter) => dispatch(actions.getList(filter)),
    funcCancelWithdraw: (data) => dispatch(actions.cancelWithdraw(data)),
    funcDropdown: () => dispatch(actions.getDropdown()),
    funcCryptoTransStatus: (data) => dispatch(getCryptoTransStatus(data))
  }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(CommissionWallet));

